import Tab from 'apollo-react/components/Tab';
import Tabs from 'apollo-react/components/Tabs';
import React from 'react';

import FormChangesTable from './FormChangesTable';
import { useFormSelector } from '../../../custom-hooks';
import { useTranslation } from '../../../custom-hooks/useTranslation';
import { FORM_CHANGES_TABLE_TYPES } from '../../constants/runtime.constants';
import { getDeltaChanges, getLayoutChanges } from '../../selectors/common.selectors';

const TABLE_TYPES = [
  FORM_CHANGES_TABLE_TYPES.MODIFIED,
  FORM_CHANGES_TABLE_TYPES.ADDED,
  FORM_CHANGES_TABLE_TYPES.DELETED,
  FORM_CHANGES_TABLE_TYPES.MOVED,
];

const FormChangesTabs = ({ currentTab, handleTabChange, collapseBlade }) => {
  const translateString = useTranslation();
  const deltaChanges = useFormSelector(getDeltaChanges);
  const layoutChanges = useFormSelector(getLayoutChanges);

  return (
    <>
      <Tabs value={currentTab} onChange={handleTabChange}>
        <Tab label={translateString('Modified')} disabled={!deltaChanges.controls?.length} />
        <Tab label={translateString('Added')} disabled={!layoutChanges.AddedFields?.length} />
        <Tab label={translateString('Deleted')} disabled={!layoutChanges.DeletedFields?.length} />
        <Tab label={translateString('Moved')} disabled={!layoutChanges.MovedFields?.length} />
      </Tabs>
      <FormChangesTable type={TABLE_TYPES[currentTab]} collapseBlade={collapseBlade} />
    </>
  );
};

export default FormChangesTabs;
